/**
 * Main theme JavaScript
 */

// Cart functionality
document.addEventListener('DOMContentLoaded', () => {
  console.log('Theme loaded');
});
